module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[35]156.db3e50d.woff2";